import { IPageContent } from "api/interfaces/static-content.type";
import PageHeaderDesktop from "./PageHeaderDesktop";
import { DEFAULT_MAKE_MODEL_BANNER } from "./make-model-year-utils";

interface IProps{
  staticContent: IPageContent;
}

function PageHeader(props: IProps) {
  const {
    vehicle, pageDetails, makeUrl, staticContent, breadCrumbsV2, selectionOrder,
  } = props;
  return (
    <>
      <div style={{ paddingTop: "calc(0.5 * var(--safari-root-font, 10px))", position: "relative" }}>

        <PageHeaderDesktop
          {...{
            vehicle,
            makeUrl,
            pageDetails,
            fallbackImage: DEFAULT_MAKE_MODEL_BANNER,
            staticContent,
            breadCrumbsV2,
            selectionOrder,
          }}
        />
      </div>
    </>
  );
}

export default PageHeader;
